import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTable = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 19,
	height: 18,
	viewBox: "0 0 19 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M2.97266 3.86085C2.97266 3.38667 3.3937 3.00391 3.91529 3.00391H15.2269C15.7485 3.00391 16.1695 3.38667 16.1695 3.86085V14.1441C16.1695 14.6183 15.7485 15.0011 15.2269 15.0011H3.91529C3.3937 15.0011 2.97266 14.6183 2.97266 14.1441V3.86085Z",
			stroke: "#3C59F6",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.42188 7.05469H16.0189",
			stroke: "#3C59F6",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.57031 15.0011L9.57031 3.00391",
			stroke: "#3C59F6",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.42188 10.9531H16.0189",
			stroke: "#3C59F6",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgTable;
